import React from "react";
import styled from "styled-components";

import { CommonBasePage } from "../common";
import { useRouteControls } from "../../routes";
import Link from "../../components/style/Link";

const A = styled.div`
  font-size: 400%;
  margin-top: 40px;
`;
const B = styled.div`
  font-size: 250%;
  margin-top: 20px;
`;
const C = styled(Link)`
  display: inline-block;
  margin-top: 30px;
  text-decoration: underline;
  font-size: 150%;
`;

const Error404: React.FunctionComponent = () => {
  const routeControls = useRouteControls();

  return (
    <CommonBasePage>
      <A>oh no!</A>
      <B>we couldn't find what you were looking for</B>
      <C onClick={routeControls.goTo.home}>go back home</C>
    </CommonBasePage>
  );
};

export default Error404;
